export * from '@fhs/routing/src/routes/v2/offers/guide/[offerId]';
export { default } from '@fhs/routing/src/routes/v2/offers/guide/[offerId]';
